import type ValueList from '@interfaces/ValueList';
import classNames from 'classnames';
import type {GenericFieldHTMLAttributes, FieldConfig} from 'formik';
import {ErrorMessage, Field, useFormikContext} from 'formik';
import type {ReactElement} from 'react';

interface Props {
    name: string;
    isEditable?: boolean;
    value?: number;
    className?: string;
    withErrorMessage?: boolean;
    currency?: string;
}

type FullProps = Props & FieldConfig & GenericFieldHTMLAttributes;

export default function SumField(props: FullProps): ReactElement<FullProps> {
    const {name, className, withErrorMessage, isEditable, value, currency, ...rest} = {
        withErrorMessage: false,
        className: '',
        isEditable: false,
        currency: 'rub',
        ...props,
    };

    const formik = useFormikContext<ValueList>();
    const classes = classNames({
        [className]: className,
        'sum-field': true,
        error: formik.touched[name] && formik.errors[name],
    });

    return (
        <>
            {isEditable ? (
                <div className={`sum-field__container--${currency}`}>
                    <Field
                        name={name}
                        className={classes}
                        type="number"
                        placeholder="Введите сумму"
                        {...rest}
                    />
                    {withErrorMessage ? (
                        <div className="error-message">
                            <ErrorMessage name={name} />
                        </div>
                    ) : null}
                </div>
            ) : null}
            {!isEditable && <div className={`sum-field__static-sum--${currency}`}>{value}</div>}
        </>
    );
}
